import React from 'react'
import {
  Sidebar,
  Featured
} from './index'
import { useSelector } from 'react-redux'
import PaginatedList from './paginated-list'
import { QUERY_BLACKLIST as BLACKLIST } from '../../../constants'

const MainContent = ({
  embed,
  defaultFeaturedItems,
  stateKey = 'resources',
  pageConfig,
  actions
}) => {
  const query = useSelector(state => state[stateKey].query)
  const data = useSelector(state => state[stateKey].data)
  const filteredKeys = Object.keys(query).filter(key => BLACKLIST.includes(key) === false)
  const showFeatured = filteredKeys.length === 0

  return (
    <>
      <section className="container mx-auto hidden lg:block">
        <div className={`flex flex-wrap -mx-4 ${!embed && 'py-16'}`}>
          <aside className="w-3/12 px-4">
            <Sidebar query={query}/>
          </aside>
          <main className="w-9/12 px-4">
            <React.Fragment>
              {
                showFeatured &&
                <Featured embed={embed} defaultItems={defaultFeaturedItems}/>
              }
              <PaginatedList
                query={query}
                defaultData={data}
                stateKey={stateKey}
                pageConfig={pageConfig}
                actions={actions}
              />
            </React.Fragment>
          </main>
        </div>
      </section>
    </>
  )
}

export { MainContent }
